import React, { Component } from "react";
import { Row, Col, notification, Button, Form, Input, Modal } from "antd";
import { add, update, getDetails } from "../api/Apis";

export default class Invitation extends Component {
  constructor(props) {
    super(props);
    this.state = { sending: false };
  }

  sendLenderInivitaion = async (value) => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.setState({ sending: true });

    const data = {
      entityData: {
        firstName:   value.lenderFirstName,
        lastName:    value.lenderLastName,
        email:       value.lenderEmail,
        agentName:   userDetails.firstName + " " + userDetails.lastName,
        agentId:     userDetails.id,
        typeOfUser:  this.props.invitationTitle,
      },
    };

    try {
      const result = await add("sendInvitation", data);
      if (result.success) {
        // ── Save invite history to agent's user record ──────────────────────
        try {
          const fresh = await getDetails("users", userDetails.id);
          const existing = fresh?.data?.invitationHistory || [];

          // Avoid duplicate entries for same email
          const alreadyInvited = existing.some(
            inv => inv.email?.toLowerCase() === value.lenderEmail?.toLowerCase()
          );

          if (!alreadyInvited) {
            const newInvite = {
              email:     value.lenderEmail.toLowerCase(),
              firstName: value.lenderFirstName,
              lastName:  value.lenderLastName,
              type:      this.props.invitationTitle === "agent"  ? "AG"
                       : this.props.invitationTitle === "lender" ? "L"
                       : this.props.invitationTitle === "Lendor" ? "L"
                       : this.props.invitationTitle === "vendor" ? "V"
                       : "AG",
              sentAt:    new Date().toISOString(),
              status:    "pending",
            };

            await update("users", userDetails.id, {
              entityData: {
                invitationHistory: [...existing, newInvite],
                invitationCount: (fresh?.data?.invitationCount || 0) + 1,
              },
            });

            // Update localStorage so header count reflects change
            const updatedDetails = {
              ...userDetails,
              invitationHistory: [...existing, newInvite],
              invitationCount: (fresh?.data?.invitationCount || 0) + 1,
            };
            localStorage.setItem("userDetails", JSON.stringify(updatedDetails));
          }
        } catch (historyErr) {
          // Don't fail the invite if history save fails — just log it
          console.warn("Could not save invite history:", historyErr.message);
        }
        // ── End history save ────────────────────────────────────────────────

        notification["success"]({ message: "Invitation sent successfully!" });
        this.setState({ sending: false });
        this.props.handleCloseInvitationModal();

        if (this.props.buyerInvitaion) {
          const agentName = value.lenderFirstName + " " + value.lenderLastName;
          this.props.submitPreferedAgent(agentName, value.lenderEmail);
        }
      } else {
        throw new Error(result.errors || "Failed to send");
      }
    } catch (error) {
      console.log(error);
      this.setState({ sending: false });
      this.props.handleCloseInvitationModal();
      notification["error"]({
        message: "Something went wrong... please try again",
      });
    }
  };

  handleInvitaionpPop = () => {
    const { sending } = this.state;
    return (
      <>
        <Row style={{ padding: "10px" }}>
          <Col span={24}>
            <Form
              initialValues={{ remember: true }}
              onFinish={this.sendLenderInivitaion}
              id="form"
            >
              <div className="form-titles">First Name</div>
              <Form.Item
                name="lenderFirstName"
                rules={[{ required: true, message: "Please input First name" }]}
              >
                <Input placeholder="First Name" className="form-input" />
              </Form.Item>

              <div className="form-titles">Last Name</div>
              <Form.Item
                name="lenderLastName"
                rules={[{ required: true, message: "Please input Last name!" }]}
              >
                <Input placeholder="Last Name" className="form-input" />
              </Form.Item>

              <div className="form-titles">Email</div>
              <Form.Item
                name="lenderEmail"
                rules={[{ required: true, message: "Please input email!" }]}
              >
                <Input placeholder="Email" className="form-input" />
              </Form.Item>
            </Form>
          </Col>

          {this.props.buyerInvitaion && (
            <Col span={24}>
              <Button
                key="back"
                onClick={() => this.props.handleCloseInvitationModal()}
                style={{ paddingRight: "10%" }}
              >
                &nbsp;&nbsp; Cancel
              </Button>
              &nbsp;&nbsp;
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                form="form"
                loading={sending}
              >
                Invite and Continue
              </Button>
            </Col>
          )}
        </Row>
      </>
    );
  };

  render() {
    const { enableInvitationModal, invitationTitle, buyerInvitaion } = this.props;
    const { sending } = this.state;

    return (
      <div>
        {buyerInvitaion ? (
          this.handleInvitaionpPop()
        ) : (
          <Modal
            className="modal-black-close"
            visible={enableInvitationModal}
            title={`Send invitation to ${invitationTitle}`}
            onCancel={() => this.props.handleCloseInvitationModal()}
            footer={[
              <Button
                key="back"
                onClick={() => this.props.handleCloseInvitationModal()}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                form="form"
                loading={sending}
              >
                Invite
              </Button>,
            ]}
          >
            {this.handleInvitaionpPop()}
          </Modal>
        )}
      </div>
    );
  }
}
